export const RANGES = {
    WEEK: 'week',
    MONTH: 'month',
    YEAR: 'year',
};